import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import { resolveRouteServiceApp } from 'utils/routing/routeHelpers'

import RedirectRule from './component'

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
}

export default withSiteContext(
  CurriculumRouteContentGetter(RedirectRule, options),
)
